'use client';

import { useOutsideClick } from 'outsideclick-react';
import { ChangeEvent, useState } from 'react';
import toast from 'react-hot-toast';
import * as yup from 'yup';
interface useSupportProps {
    setShowSupportForm?: (val: boolean) => void;
}
const useSupport = ({ setShowSupportForm }: useSupportProps) => {
    const [open, setOpen] = useState(false);
    const init_message = {
        code: 0,
        message: '',
        data: '',
    };
    const handleClickOpen = () => {
        setOpen(!open);
        setMessage(init_message);
    };
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState('No file chosen');
    const [dragOver, setDragOver] = useState(false);
    const [message, setMessage] = useState(init_message);
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file || !['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)) {
            toast.error('Please select an image file (jpg, png, gif, webp)', { duration: 5000 });
            return;
        }
        if (file.size > 10 * 1000 * 1024 || file.size < 0) {
            toast.error('Please select an image file less than 10MB', { duration: 5000 });
            return;
        }
        setSelectedFile(file);
        setFileName(file.name);
    };
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        issue: '',
        additionalDetails: '',
    });

    // Define the type for the errors state
    type Errors = {
        firstName?: string;
        email?: string;
        issue?: string;
        additionalDetails?: string;
    };

    const supportFormSchema = yup.object().shape({
        firstName: yup.string().required('Name  is required'),
        email: yup.string().email('Email is not valid').required('Email is required'),
        issue: yup.string().required('Query  is required'),
        additionalDetails: yup.string().required('Additional details  is required'),
    });
    const validateField = async (fieldName: keyof Errors | string, value: string) => {
        try {
            await yup.reach(supportFormSchema, fieldName).validate(value);
            setErrors({ ...errors, [fieldName]: '' });
        } catch (error: any) {
            setErrors({ ...errors, [fieldName]: error.message });
        }
    };

    const [errors, setErrors] = useState<Errors>({});
    const handleInputChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
        validateField(event.target.name, event.target.value);
    };
    const handleReset = () => {
        setFileName('No file chosen');
        setSelectedFile(null);
    };
    // const handleUpload = () => {
    //   const formData = new FormData();
    //   formData.append('file', selectedFile);
    //   axios.post('/upload', formData)
    //     .then(response => console.log(response))
    //     .catch(error => console.error(error));
    // };

    const handleDragOver = (event: any) => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleDragEnter = (event: any) => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleDrop = (event: any) => {
        event.preventDefault();
        setDragOver(false);
        setSelectedFile(event.dataTransfer.files[0]);
        setFileName(event.dataTransfer.files[0].name);
    };
    const handleOutsideClick = (e: any) => {
        // Handle outside click
        setOpen(false);
        setMessage(init_message);
        setShowSupportForm && setShowSupportForm(false);
    };
    const outSideRef = useOutsideClick(handleOutsideClick);
    return {
        handleClickOpen,
        open,
        handleFileChange,
        fileName,
        handleDrop,
        handleDragLeave,
        handleDragEnter,
        handleDragOver,
        dragOver,
        handleReset,
        selectedFile,
        outSideRef,
        formData,
        handleInputChange,
        errors,
        supportFormSchema,
        setErrors,
        setMessage,
        message,
        setFormData,
        handleOutsideClick,
    };
};

export default useSupport;
